/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeExtensionColors } from 'utils/theme';

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - COMPONENT - AVATAR : STYLES --------------- ++++++++++ */
// Based on embeds-ui Avatar extensionClasses
export default theme => ({
  avatar: {
    '& svg': {
      '& .ext1_1': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['1_1'].background
      },
      '& .ext1_1_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['1_1'].color
      },

      '& .ext1_2': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['1_2'].background
      },
      '& .ext1_2_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['1_2'].color
      },

      '& .ext2_1': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['2_1'].background
      },
      '& .ext2_1_stroke_i': {
        stroke: props => themeExtensionColors[props.extension || 'DEFAULT']['2_1'].color
      },
      '& .ext2_1_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['2_1'].color
      },

      '& .ext2_2': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['2_2'].background
      },
      '& .ext2_2_stroke': {
        stroke: props => themeExtensionColors[props.extension || 'DEFAULT']['2_2'].background
      },
      '& .ext2_2_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['2_2'].color
      },


      '& .ext3_1': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['3_1'].background
      },
      '& .ext3_1_stroke': {
        stroke:  props => themeExtensionColors[props.extension || 'DEFAULT']['3_1'].background
      },
      '& .ext3_1_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['3_1'].color
      },


      '& .ext3_2': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['3_2'].background
      },
      '& .ext3_2_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['3_2'].color
      },

      '& .ext4_1': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['4_1'].background
      },
      '& .ext_4_1_stroke': {
        stroke: props => themeExtensionColors[props.extension || 'DEFAULT']['4_1'].background
      },
      '& .ext4_1_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['4_1'].color
      },


      '& .ext4_2': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['4_2'].background
      },
      '& .ext4_2_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['4_2'].color
      },

      '& .ext5_1': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['5_1'].background
      },
      '& .ext5_1_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['5_1'].color
      },

      '& .ext5_2': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['5_2'].background
      },
      '& .ext5_2_i': {
        fill: props => themeExtensionColors[props.extension || 'DEFAULT']['5_2'].color
      },
    }
  }
});
